export enum TagCloud {
  cartLegalTerms = 'Cart Legal Terms',
  carrouselCartEn = 'Carrousel Cart EN',
  carrouselCartEs = 'Carrousel Cart ES',
  carrouselCartCa = 'Carrousel Cart CA',
  technicalSheet = 'Ficha tecnica',
}
